import { getAxiosClient } from "../../axios-client";
import { GetAllOrdersRequestBody, GetAllOrdersResponse } from "./types";

const axiosClient = getAxiosClient();
export const getAllOrders = async (body: GetAllOrdersRequestBody) => {
  return await axiosClient.ax.post<GetAllOrdersResponse>(
    "/Orders/GetAll",
    body
  );
};
